export const dropdownValues = [
  {
    value: 'qualifications.LIHTC',
    text: '(LIHTC) Qualifications/ Personal data',
    disabled: false,
    lihtc: true,
  },
  {
    value: 'qualifications.HOME',
    text: '(HOME) Qualifications/ Personal data',
    disabled: false,
    home: true,
  },
  {
    value: 'qualifications.NOAH',
    text: '(NOAH) Qualifications/ Personal data',
    disabled: false,
    noah: true,
  },

  {
    value: 'qualifications.Deferred Loan',
    text: '(Deferred Loan) Qualifications/ Personal data',
    disabled: false,
    deferredLoan: true,
  },
  {
    value: 'qualifications.VHCB',
    text: '(VHCB) Qualifications/ Personal data',
    disabled: false,
    vhcb: true,
  },
  {
    value: 'qualifications.NSP',
    text: '(NSP) Qualifications/ Personal data',
    disabled: false,
    nsp: true,
  },
  {
    value: 'qualifications.AHP',
    text: '(AHP) Qualifications/ Personal data',
    disabled: false,
    ahp: true,
  },
  {
    value: 'qualifications.KCMO',
    text: '(KCMO) Qualifications/ Personal data',
    disabled: false,
    kcmo: true,
  },
  {
    value: 'qualifications.StLouisFunds',
    text: '(St. Louis Funds) Qualifications/ Personal data',
    disabled: false,
    stLouisFunds: true,
  },
  {
    value: 'qualifications.HTF',
    text: '(HTF) Qualifications/ Personal data',
    disabled: false,
    htf: true,
  },
  {
    value: 'qualifications.TCAP',
    text: '(TCAP) Qualifications/ Personal data',
    disabled: false,
    tcap: true,
  },
  {
    value: 'qualifications.BOND',
    text: '(BOND) Qualifications/ Personal data',
    disabled: false,
    bond: true,
  },
  {
    value: 'picbaseline',
    text: '(PH) Qualifications/ Personal data',
    disabled: false,
    ph: true,
  },
  {
    value: 'assets',
    text: 'Assets',
    disabled: false,
  },
  {
    value: 'income',
    text: 'Incomes',
    disabled: false,
  },
  {
    value: 'documents',
    text: 'Documents',
    disabled: false,
  },
  {
    value: 'pets',
    text: 'Pets',
    disabled: false,
  },
  {
    value: 'waitlist',
    text: 'Affordable Waitlist',
    disabled: false,
  },
  {
    value: 'mincbaseline',
    text: 'MINC Baseline',
    disabled: false,
    rd: true,
  },
  {
    value: 'matbaseline',
    text: 'MAT Baseline',
    disabled: false,
    hud: true,
  },
  {
    value: 'matbaseline-noprior',
    text: 'MAT Baseline (Skip households with MO certs)',
    disabled: false,
    hud: true,
  },
  {
    value: 'matbaseline-rentupdates',
    text: 'MAT Baseline (Create Floorplan Rents and UAs - Slower)',
    disabled: false,
    hud: true,
  },
];
